// extracted by mini-css-extract-plugin
export default {"GiftSummary__ProductInfo":"GiftSummary-styles__GiftSummary__ProductInfo__M3rfj","GiftSummary__ProductTitle":"GiftSummary-styles__GiftSummary__ProductTitle__kTZpe"};